import Vue from 'vue';
import noop from 'lodash/noop';

export default {
  template: '<div></div>',
  bindings: {
    rfp: '<'
  },
  controller: Ctrl,
}

Ctrl.$inject = ['$element'];
function Ctrl($element){
  const
    vm = this;

  let
    vueComponent = null;

  Object.assign(this, {

    $onInit () {
      import( /* webpackChunkName: 'TheViewHotelRateQuickRfp' */ 'vRoot/rfp-hotel/rfp/rate-quick/view/TheViewHotelRateQuickRfp.vue')
        .then( imported => {
          vueComponent = new Vue({
            el: $element[0],
            render ( h ) {
              return h( imported.default, {
                props: {
                  rfp: vm.rfp,
                },
              });
            },
          });
        })
        .catch( noop );
    },

    $onDestroy () {
      if(vueComponent) {
        vueComponent.$destroy();
      }
    },
  });
}
